import React, { Component } from "react";
import { Tabs, Tab } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { TabStrip } from "../TabStrip";
import MainSiteHome from "./MainSiteHome";

export var styles = function styles(theme) {
	return {
		menuRoot: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			height: "100%",
			display: "flex",
			flexDirection: "column",
		},
		container: {
			flex: "0 0 100%",
			backgroundColor: "white",
			padding: "0px",
		},
		menuItem: {
			textAlign: "center",
			cursor: "pointer",
			"&:hover, & div:hover": {
				backgroundColor: theme.palette.primary.dark,
				transition: "0.3s",
			},
		},
		menuItemSelected: {
			backgroundColor: theme.palette.primary.dark,
		},
		logo: {
			height: "150px",
			width: "auto",
		},
		mainWrapper: {
			height: "100%",
			justifyContent: "center",
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
			backgroundColor: "#f2f2f2",
		},
		logoWrapper: {
			display: "flex",
			justifyContent: "center",
		},
		contentWrapper: {
			width: "80%",
			flex: "1",
			display: "flex",
			flexDirection: "column",
			height: "100%",
		},
		navMenu: {
			display: "flex",
			justifyContent: "center",
			border: "1px solid #ccc",
			borderLeftWidth: "0px",
			borderRightWidth: "0px",
			marginBottom: "4px",
			// backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		},
		mainContent: {
			flex: "1",
			display: "flex",
			flexDirection: "column",
			height: "calc(100% - 198px)",
			overflowY: "auto",
		},
		"MuiTabs-indicator": {
			backgroundColor: theme.palette.primary.contrastText,
		},
	};
};

class MainSite extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedTab: 0,
		};
	}

	render() {
		var tabs = [
			{ display: "Home", component: <MainSiteHome></MainSiteHome> },
			{ display: "About Us", component: <div>Test</div> },
			{ display: "Contact", component: <div>Test</div> },
			{ display: "Services", component: <div>Test</div> },
		];

		return (
			<div className={[this.props.classes.mainWrapper, this.props.classes.container].join(" ")}>
				<div className={this.props.classes.contentWrapper}>
					<div className={this.props.classes.logoWrapper}>
						<img className={this.props.classes.logo} src="/img/logo.png"></img>
					</div>
					<div className={this.props.classes.navMenu}>
						<div style={{ display: "inline-block" }}>
							<Tabs value={this.state.selectedTab} indicatorColor="primary" onChange={(ev, idx) => this.setState({ selectedTab: idx })}>
								{tabs.map((item, idx) => {
									return <Tab key={idx} label={item.display}></Tab>;
								})}
							</Tabs>
						</div>
					</div>
					<div className={this.props.classes.mainContent}>
						{tabs.map((tab, idx) => {
							var hdn = idx !== this.state.selectedTab;
							return (
								<div style={{ flex: "1 1 auto !important" }} key={idx} hidden={hdn} className={hdn ? "" : "d-flex flex-column flex-fill"}>
									{tab.component}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(MainSite);
